import * as React from "react";

const NameTemplate = (name: string, header?: string) => {
  return (
    <div>
      {header && (
        <span>
          <span className="ml-20 text-sm font-semibold lg:hidden lg:ml-0">
            {header}
          </span>
          <span className="mx-2 lg:hidden">-</span>
        </span>
      )}
      <span>{name}</span>
    </div>
  );
};

export default NameTemplate;
